import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
//@mui
import { Box } from '@mui/material';
//components
import CostSummary from '../../../components/chancemng/costcalc/CostSummary';
import CostCalcLockList from '../../../components/chancemng/costcalc/CostCalcLockList';
import { useDispatch } from 'react-redux';
import { listChanceCosts } from '../../../modules/chanceModule/chanceCosts';

const OrderProductListContainer = () => {
  const dispatch = useDispatch();
  const { chance, costs } = useSelector(({ chanceModule }) => ({
    chance: chanceModule.chance.chance,
    costs: chanceModule.chanceCosts.costs,
  }));

  useEffect(() => {
    dispatch(listChanceCosts(chance.prjUuid));
  }, [chance]);

  // useEffect(() => {
  //   if (costs) {
  //     console.log(costs, 'costs');
  //   }
  // }, [costs]);

  return (
    <Box>
      <Box
        sx={{
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          py: 1,
        }}
      >
        <CostSummary chance={chance} costsVat={costs} />
      </Box>
      <Box
        sx={{
          py: 1,
        }}
      >
        {costs && <CostCalcLockList costs={costs} />}
      </Box>
    </Box>
  );
};

export default OrderProductListContainer;
